import { Box } from "@mui/material";
import { TimeCheckWrapper } from "../style";
import { Time, TimeInOutLable } from "../CustomCalendarHeader/style";
import pxToRem from "theme/base/pxToRem";
import moment from "moment";

export interface LackOfTimeCheckingProps {
  lateDuration?: string;
  earlyLeaveDuration?: string;
  earlyLeaveRequest?: string;
  lateRequest?: string;
  day?: string;
}

export const LackOfTimeChecking = ({
  lateDuration,
  earlyLeaveDuration,
  day,
}: LackOfTimeCheckingProps) => {
  const isToday = day === moment().format("DD/MM/YYYY");
  return (
    <Box>
      {(!!lateDuration || (!!earlyLeaveDuration && !isToday)) && (
        <TimeCheckWrapper dayType="lackOfTimeChecking">
          {!!lateDuration && (
            <Box display="flex" gap={pxToRem(2)}>
              <TimeInOutLable>Đi muộn: </TimeInOutLable>{" "}
              <Time>{lateDuration} phút</Time>
            </Box>
          )}

          {!!earlyLeaveDuration && !isToday && (
            <Box display="flex" gap={pxToRem(2)}>
              <TimeInOutLable>Về sớm: </TimeInOutLable>
              <Time>{earlyLeaveDuration} phút</Time>
            </Box>
          )}
        </TimeCheckWrapper>
      )}
    </Box>
  );
};
